export type OfflineReason = {
  code: string | null;
  message: string;
  more_info: string | null;
};

const BASE = "dashboard.settings.whatsappChannel.offlineReason";

// Only codes whose meaning is specific and actionable. A generic provider message such as
// "Something went wrong" keeps its own words rather than being dressed up as a diagnosis.
const KNOWN_CODES: Record<string, string> = {
  "63110": `${BASE}.alreadyRegistered`,
};

export const offlineReasonKey = (code: string | null): string | null =>
  code && KNOWN_CODES[code] ? KNOWN_CODES[code] : null;

export const hasOfflineReasons = (reasons?: OfflineReason[] | null): boolean =>
  Array.isArray(reasons) && reasons.length > 0;
